import moduleInfo from '../module.json';
import type { AppRuntime } from '@ayocore/platform/client/runtime/AppRuntime';
import { IconPackage } from '@tabler/icons-react';
import { lazy } from 'react';

/**
 * Модуль Catalog — справочник каталога и товаров.
 * Регистрирует пункт меню «Товары».
 */
export async function setup(app: AppRuntime): Promise<void> {
  const catalog = app.useModule(moduleInfo.name, {
    version: moduleInfo.version,
    description: moduleInfo.description,
  });

  catalog.useNavigation([
    {
      icon: IconPackage,
      label: 'Товары',
      url: '/catalog/products',
      component: lazy(() => import('./components/CatalogTreeView')),
    },
  ]);
}
